__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("clsx", "1.2.1", () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(7967))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(285), __webpack_require__.e(936)]).then(() => (() => (__webpack_require__(6285))))));
			register("framer-motion", "10.16.1", () => (Promise.all([__webpack_require__.e(418), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(3418))))));
			register("mobx-react", "7.5.3", () => (Promise.all([__webpack_require__.e(204), __webpack_require__.e(376), __webpack_require__.e(970), __webpack_require__.e(957)]).then(() => (() => (__webpack_require__(9204))))));
			register("mobx", "6.6.2", () => (__webpack_require__.e(137).then(() => (() => (__webpack_require__(137))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(131), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(5131))))));
			register("react-lazily", "0.9.1", () => (Promise.all([__webpack_require__.e(376), __webpack_require__.e(794)]).then(() => (() => (__webpack_require__(2794))))));
			register("react-router-dom", "6.11.2", () => (Promise.all([__webpack_require__.e(10), __webpack_require__.e(376)]).then(() => (() => (__webpack_require__(10))))));
			register("react", "18.2.0", () => (__webpack_require__.e(150).then(() => (() => (__webpack_require__(5150))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(747).then(() => (() => (__webpack_require__(1747))))));
			initExternal(9322);
			initExternal(2166);
			initExternal(5170);
			initExternal(6738);
			initExternal(760);
			initExternal(8133);
			initExternal(4342);
			initExternal(9174);
			initExternal(108);
			initExternal(2066);
			initExternal(3050);
			initExternal(5566);
			initExternal(1662);
			initExternal(50);
			initExternal(8474);
			initExternal(586);
			initExternal(3560);
			initExternal(936);
			initExternal(1626);
			initExternal(3142);
			initExternal(9472);
			initExternal(5426);
			initExternal(4078);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};